import { capitalizeFirstLetter } from "./utils";

export enum NamesSection {
    TraditionalNames,
    InventedNames,
    CompoundNames,
    MultiwordNames,
    RealwordNames
}

export type LogoData =
{
    img_url: string;
    studio_url: string;
    id: string
}


export type LogoDataResponse = {
    data: LogoData[];
    total: number
};

export type NameSectionProps = {
    title: string,
    showSeeMore: (nameSection: NamesSection) => boolean,
    onSeeMoreClick: (nameSection: NamesSection) => void,
    onNameItemClick: (word: string, keywords: string[], selectedTextLogo: LogoData | undefined) => void
    namesList: (KeywordCombinations | null)[],
    textLogoUrls: LogoData[],
    sectionType: NamesSection,
    randomOffset: number,
    useTextLogos?: boolean
}


export type KeywordDetails = {
    keyword: String,
    synonyms: Array<String>
}

export interface IDictionary {
    [index: string]: number;
}

export interface KeywordCombinations {
    word: string,
    keywords: string[]
}

export interface GeneratedWord {
    word: string;
}

export type AlternameNames = {
    name: string,
    categories: string[],
    keywords: string[]
}

export function stringToGeneratedWord(str: string) {
    return { word: capitalizeFirstLetter(str) }
}

export function stringToKeywordCombinations(str: string, keywords: string[] = []) : KeywordCombinations {
    return { word: capitalizeFirstLetter(str), keywords}
}


export type CheckDomainResponse = {
    Domain: string[],
    RRPCode: string[],
    RRPText: string[]
}

export type VerifiedDomainNames = {
    domainName: string,
    isRegistered: boolean
}

export type NameGeneratorResponse = {
    inventedNames: KeywordCombinations[],
    compoundNames: KeywordCombinations[],
    multiWordNames: KeywordCombinations[],
    synonyms: string[]
}

export type LDLogoData = {
    id: string;
    symbol: string;
    alttext: string;
    imgtext: string;
    slugtext: string;
    symboldesc: string;
    symbolKeywords: string;
    createdAt: string;
    type: null;
    background_color: string;
    companyName: string;
    studioURL: string;
    imageURL: string;
};


export type LDLogoDataResponse = {
    logoData: LDLogoData[]
}

export type LDSymbolResponse = {
    studioURL: string;
    imageURL: string;
    id: string;
    status: number
}